<template>
  <div>
    <h2 class="page-title">我的名片</h2>

    <div class="preview-grid">
      <div class="card-panel">
        <h3 class="section-title">公开名片链接</h3>
        <p class="section-desc">公开名片可用于手机端访问、第三方主页展示和打印。</p>
        <div class="info-grid">
          <div class="info-item">
            <div class="info-label">名片地址</div>
            <div class="info-value code-text">{{ cardUrl || '-' }}</div>
          </div>
          <div class="info-item">
            <div class="info-label">平台 ID</div>
            <div class="info-value code-text">{{ profile.shortCode || '-' }}</div>
          </div>
          <div class="info-item">
            <div class="info-label">主体类型</div>
            <div class="info-value">{{ profile.supplierTypeText || '-' }}</div>
          </div>
        </div>
        <div class="action-row">
          <el-button type="primary" @click="openCard">预览名片</el-button>
          <el-button @click="copyCardUrl">复制链接</el-button>
          <el-button @click="printCard">打印名片</el-button>
        </div>
      </div>

      <div class="card-panel qr-panel">
        <h3 class="section-title">名片二维码</h3>
        <canvas ref="cardQr" class="manage-qr"></canvas>
      </div>
    </div>

    <div class="card-panel">
      <h3 class="section-title">名片展示资料</h3>
      <p class="section-desc">头像/Logo 使用本地上传文件；作者主页会展示在公开名片中，URL 需以 http:// 或 https:// 开头。</p>
      <el-form :model="profileForm" label-position="top" class="form-grid">
        <el-form-item label="头像/Logo">
          <div class="avatar-upload-row">
            <img v-if="avatarPreview" :src="avatarPreview" class="avatar-preview" alt="头像/Logo" />
            <el-upload :show-file-list="false" :http-request="uploadAvatar" accept="image/png,image/jpeg,image/webp">
              <el-button>上传头像/Logo</el-button>
            </el-upload>
            <el-button v-if="profileForm.avatarUrl" type="text" @click="clearAvatar">移除头像</el-button>
          </div>
        </el-form-item>
        <el-form-item label="作者主页URL">
          <el-input v-model="profileForm.authorHomeUrl" placeholder="例如 https://example.com/author" />
        </el-form-item>
      </el-form>
      <div class="action-row">
        <el-button type="primary" @click="saveProfile">保存展示资料</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import { getVendorProfile, updateVendorProfile } from '../../api/vendor'

export default {
  data() {
    return {
      profile: {},
      profileForm: {
        avatarUrl: '',
        authorHomeUrl: '',
      },
    }
  },
  computed: {
    cardPath() {
      return this.profile.vendorCode ? `/card/${this.profile.vendorCode}` : ''
    },
    cardUrl() {
      if (!this.cardPath) return ''
      const base = `${window.location.origin}${window.location.pathname}`
      return `${base}#${this.cardPath}`
    },
  },
  created() {
    this.loadProfile()
  },
  methods: {
    async loadProfile() {
      const { data } = await getVendorProfile()
      this.profile = data
      this.profileForm.avatarUrl = data.avatarUrl || ''
      this.profileForm.authorHomeUrl = data.authorHomeUrl || ''
      this.$nextTick(this.renderQr)
    },
    renderQr() {
      if (!this.cardUrl || !this.$refs.cardQr) return
      QRCode.toCanvas(this.$refs.cardQr, this.cardUrl, { width: 220, margin: 1 })
    },
    async saveProfile() {
      try {
        await updateVendorProfile(this.profileForm)
        this.$message.success('名片展示资料已保存')
        this.loadProfile()
      } catch (error) {
        this.$message.error(error.response?.data?.message || '保存失败')
      }
    },
    async uploadAvatar(option) {
      try {
        const { data } = await uploadVendorAvatar(option.file)
        this.profileForm.avatarUrl = data.avatarUrl
        this.$message.success('头像已上传，请保存展示资料')
      } catch (error) {
        this.$message.error(error.response?.data?.message || '上传失败')
      }
    },
    clearAvatar() {
      this.profileForm.avatarUrl = ''
    },
    async copyCardUrl() {
      if (!this.cardUrl) return
      try {
        await navigator.clipboard.writeText(this.cardUrl)
        this.$message.success('名片链接已复制')
      } catch (error) {
        this.$message.error('复制失败，请手动复制')
      }
    },
    openCard() {
      if (this.cardPath) window.open(`/#${this.cardPath}`, '_blank', 'noopener,noreferrer')
    },
    printCard() {
      if (this.cardPath) window.open(`/#${this.cardPath}`, '_blank', 'noopener,noreferrer')
    },
  },
}
</script>

<style scoped>
.qr-panel {
  text-align: center;
}

.manage-qr {
  width: 220px;
  height: 220px;
  max-width: 100%;
  padding: 10px;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  background: #fff;
}

.avatar-upload-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.avatar-preview {
  width: 72px;
  height: 72px;
  border-radius: 18px;
  object-fit: cover;
  border: 1px solid #e5e7eb;
}
</style>
